import React from 'react';
import Svg, {
  G,
  Path,
  Defs,
  Filter,
  FeFlood,
  FeColorMatrix,
  FeOffset,
  FeComposite,
  FeBlend,
  LinearGradient,
  Stop,
  ClipPath,
  RadialGradient,
} from 'react-native-svg';

const LeaderTwoIcon = () => {
  return (
    <Svg width={48} height={49} viewBox="0 0 48 49" fill="none">
      <Defs>
        <Filter
          id="filter0_d_313_852"
          x={0}
          y={0}
          width={48}
          height={49}
          filterUnits="userSpaceOnUse"
        >
          <FeFlood floodOpacity={0} result="BackgroundImageFix" />
          <FeColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <FeOffset dy={1} />
          <FeComposite in2="hardAlpha" operator="out" />
          <FeColorMatrix
            type="matrix"
            values="0 0 0 0 0.117138 0 0 0 0 0.176258 0 0 0 0 0.202862 0 0 0 1 0"
          />
          <FeBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_313_852"
          />
          <FeBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_313_852"
            result="shape"
          />
        </Filter>

        <LinearGradient
          id="paint0_linear_313_852"
          x1={23.9999}
          y1={51.6118}
          x2={23.9999}
          y2={-3.61166}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#8AA8B5" />
          <Stop offset={1} stopColor="#DCE5E8" />
        </LinearGradient>

        <ClipPath id="clip_star_inner">
          <Path d="M23.1935 16.4916C23.5314 15.8361 24.4686 15.8361 24.8065 16.4916L26.953 20.6562C27.0395 20.8239 27.1761 20.9605 27.3438 21.047L31.5084 23.1935C32.1639 23.5314 32.1639 24.4686 31.5084 24.8065L27.3438 26.953C27.1761 27.0395 27.0395 27.1761 26.953 27.3438L24.8065 31.5084C24.4686 32.1639 23.5314 32.1639 23.1935 31.5084L21.047 27.3438C20.9605 27.1761 20.8239 27.0395 20.6562 26.953L16.4916 24.8065C15.8361 24.4686 15.8361 23.5314 16.4916 23.1935L20.6562 21.047C20.8239 20.9605 20.9605 20.8239 21.047 20.6562L23.1935 16.4916Z" />
        </ClipPath>

        <RadialGradient
          id="star_radial"
          cx={24}
          cy={24}
          r={8}
          gradientUnits="userSpaceOnUse"
        >
          <Stop offset="0" stopColor="white" />
          <Stop offset="1" stopColor="#E0E0E0" />
        </RadialGradient>
      </Defs>

      <G filter="url(#filter0_d_313_852)">
        {/* Background Diamond Shape */}
        <Path
          d="M30.1656 45.4461C26.7604 48.8513 21.2396 48.8513 17.8344 45.4461L2.55388 30.1656C-0.851294 26.7604 -0.851294 21.2396 2.55388 17.8344L17.8344 2.55388C21.2396 -0.851294 26.7604 -0.851294 30.1656 2.55388L45.4461 17.8344C48.8513 21.2396 48.8513 26.7604 45.4461 30.1656L30.1656 45.4461Z"
          fill="url(#paint0_linear_313_852)"
        />
        {/* Border Path */}
        <Path
          d="M18.541 3.26074C21.5557 0.246092 26.4443 0.246092 29.459 3.26074L44.7393 18.541C47.7539 21.5557 47.7539 26.4443 44.7393 29.459L29.459 44.7393C26.4443 47.7539 21.5557 47.7539 18.541 44.7393L3.26074 29.459C0.246092 26.4443 0.246092 21.5557 3.26074 18.541L18.541 3.26074Z"
          stroke="white"
          strokeOpacity={0.4}
          strokeWidth={2}
        />
      </G>

      {/* Star Foreground */}
      <Path
        clipPath="url(#clip_star_inner)"
        d="M23.1935 16.4916C23.5314 15.8361 24.4686 15.8361 24.8065 16.4916L26.953 20.6562C27.0395 20.8239 27.1761 20.9605 27.3438 21.047L31.5084 23.1935C32.1639 23.5314 32.1639 24.4686 31.5084 24.8065L27.3438 26.953C27.1761 27.0395 27.0395 27.1761 26.953 27.3438L24.8065 31.5084C24.4686 32.1639 23.5314 32.1639 23.1935 31.5084L21.047 27.3438C20.9605 27.1761 20.8239 27.0395 20.6562 26.953L16.4916 24.8065C15.8361 24.4686 15.8361 23.5314 16.4916 23.1935L20.6562 21.047C20.8239 20.9605 20.9605 20.8239 21.047 20.6562L23.1935 16.4916Z"
        fill="url(#star_radial)"
      />

      {/* Thin Detail Stroke */}
      <Path
        d="M22.749 16.2627C23.2731 15.246 24.7269 15.246 25.251 16.2627L27.3975 20.4268C27.4363 20.5021 27.4979 20.5637 27.5732 20.6025L31.7373 22.749C32.754 23.2731 32.754 24.7269 31.7373 25.251L27.5732 27.3975C27.4979 27.4363 27.4363 27.4979 27.3975 27.5732L25.251 31.7373C24.7269 32.754 23.2731 32.754 22.749 31.7373L20.6025 27.5732C20.5637 27.4979 20.5021 27.4363 20.4268 27.3975L16.2627 25.251C15.246 24.7269 15.246 23.2731 16.2627 22.749L20.4268 20.6025C20.5021 20.5637 20.5637 20.5021 20.6025 20.4268L22.749 16.2627Z"
        stroke="black"
        strokeOpacity={0.16}
      />
    </Svg>
  );
};

export default LeaderTwoIcon;
